import {SvgIconData} from '@shared-web/components/core/svg_icon';

export const squareIcon: SvgIconData = {
  viewBox: '0 0 122.661 122.88',
  element: (
    <path d="M21.26,0h80.142c11.692,0,21.26,9.706,21.26,21.569v79.741 c0,11.864-9.567,21.569-21.26,21.569H21.26C9.566,122.88,0,113.175,0,101.311V21.569C0,9.706,9.566,0,21.26,0L21.26,0z M21.674,11.14h79.312c5.855,0,10.647,4.788,10.647,10.641v79.313c0,5.855-4.792,10.646-10.647,10.646H21.674 c-5.855,0-10.646-4.79-10.646-10.646V21.78C11.027,15.928,15.818,11.14,21.674,11.14L21.674,11.14z" />
  ),
};
